export default {
  state: {
    gclid: '',
    la: 400,
    speedyId: '',
    awKeyword: '',
    awDevice: '',
    awMatchtype: '',
    awAdpos: '',
    utmSource: '',
    utmMedium: '',
    utmTerm: '',
    utmContent: '',
    utmCampaign: '',
    lp: 'lp1',
    campaign: 'TEST',
  },
  setGclid(znew) {
    this.state.gclid = znew;
  },
  setLa(znew) {
    this.state.la = znew;
  },
  setSpeedyId(znew) {
    this.state.speedyId = znew;
  },
  setAwKeyword(znew) {
    this.state.awKeyword = znew;
  },
  setAwDevice(znew) {
    this.state.awDevice = znew;
  },
  setAwMatchtype(znew) {
    this.state.awMatchtype = znew;
  },
  setAwAdpos(znew) {
    this.state.awAdpos = znew;
  },
  setUtmSource(znew) {
    this.state.utmSource = znew;
  },
  setUtmMedium(znew) {
    this.state.utmMedium = znew;
  },
  setUtmTerm(znew) {
    this.state.utmTerm = znew;
  },
  setUtmContent(znew) {
    this.state.utmContent = znew;
  },
  setUtmCampaign(znew) {
    this.state.utmCampaign = znew;
  },
  setLp(znew) {
    this.state.lp = znew;
  },
  setCampaign(znew) {
    this.state.campaign = znew;
  },
};
